"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackFloatingButton = exports.FloatingButtonEventType = exports.trackShare = exports.ShareEventType = exports.trackHistory = exports.HistoryEventType = exports.trackHelpModule = exports.HelpModuleEventType = exports.trackClicks = exports.ClickEventType = void 0;
const libs_tracking_events_1 = require("@hotelplan/libs.tracking-events");
var ClickEventType;
(function (ClickEventType) {
    ClickEventType["CALL"] = "\uD83D\uDE80 click.call";
    ClickEventType["CHAT"] = "\uD83D\uDE80 click.chat";
    ClickEventType["BOX"] = "\uD83D\uDE80 click.box";
    ClickEventType["EMAIL"] = "\uD83D\uDE80 click.email";
    ClickEventType["APPOINTMENT"] = "\uD83D\uDE80 click.appointment";
    ClickEventType["CONTACT"] = "\uD83D\uDE80 click.contact";
})(ClickEventType || (exports.ClickEventType = ClickEventType = {}));
const trackClicks = (action) => {
    (0, libs_tracking_events_1.track)({
        event: action.type,
        eventMetadata: { source: action.payload.source },
        _clear: true,
    });
};
exports.trackClicks = trackClicks;
var HelpModuleEventType;
(function (HelpModuleEventType) {
    HelpModuleEventType["OPEN"] = "\uD83D\uDE80 help.open";
    HelpModuleEventType["CLOSE"] = "\uD83D\uDE80 help.close";
})(HelpModuleEventType || (exports.HelpModuleEventType = HelpModuleEventType = {}));
const trackHelpModule = (event, auto = false, source) => {
    (0, libs_tracking_events_1.track)({
        event,
        eventMetadata: { auto, source },
        _clear: true,
    });
};
exports.trackHelpModule = trackHelpModule;
var HistoryEventType;
(function (HistoryEventType) {
    HistoryEventType["OPEN"] = "\uD83D\uDE80 history.open";
    HistoryEventType["CLOSE"] = "\uD83D\uDE80 history.close";
})(HistoryEventType || (exports.HistoryEventType = HistoryEventType = {}));
const trackHistory = (event) => {
    (0, libs_tracking_events_1.track)({
        event,
        eventMetadata: {},
        _clear: true,
    });
};
exports.trackHistory = trackHistory;
var ShareEventType;
(function (ShareEventType) {
    ShareEventType["OPEN"] = "\uD83D\uDE80 share.open";
    ShareEventType["CLOSE"] = "\uD83D\uDE80 share.close";
})(ShareEventType || (exports.ShareEventType = ShareEventType = {}));
const trackShare = (event) => {
    (0, libs_tracking_events_1.track)({
        event,
        eventMetadata: {},
        _clear: true,
    });
};
exports.trackShare = trackShare;
var FloatingButtonEventType;
(function (FloatingButtonEventType) {
    FloatingButtonEventType["OPEN"] = "\uD83D\uDE80 float.open";
    FloatingButtonEventType["CLOSE"] = "\uD83D\uDE80 float.close";
})(FloatingButtonEventType || (exports.FloatingButtonEventType = FloatingButtonEventType = {}));
const trackFloatingButton = (event) => {
    (0, libs_tracking_events_1.track)({
        event,
        eventMetadata: {},
        _clear: true,
    });
};
exports.trackFloatingButton = trackFloatingButton;
//# sourceMappingURL=index.js.map